import * as React from "react";
import PropTypes from "prop-types";
// import Header from "./Header";
import { makeStyles } from "@fluentui/react-components";
import { outlookNotification,outlookAttachments,outlookMessage,outlookAccesToken } from "../taskpane";
import AuthProvider from "./auth/AuthProvider";
import JobParse from "./outlookParsing/JobParse";
import CandidateParse from "./outlookParsing/CandidateParse";

const useStyles = makeStyles({
  root: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    // justifyContent: "center",
    flexDirection: "column",   
    padding: "0 15px",
    backgroundColor: "#f8fcff"
  },
  outlookParseDiv: {
    display:"flex",  
    flexDirection: "column",   
    width: "100%",
    marginTop:"5px"
  }
});

const App = (props) => {
  const { title } = props;
  const [logout,setLogout] = React.useState(false);
  const styles = useStyles();

  return (
    <div className={styles.root}>
      <AuthProvider logout={logout} setLogout={setLogout}>
        {/* <Header logo="assets/logo.png" title={title} message="ExcelHire" /> */}
        <div className={styles.outlookParseDiv}>
          <JobParse outlookNotification={outlookNotification} outlookAttachments={outlookAttachments} outlookMessage={outlookMessage} outlookAccesToken={outlookAccesToken} setLogout={setLogout}/>
          <CandidateParse outlookNotification={outlookNotification} outlookAttachments={outlookAttachments} outlookMessage={outlookMessage} outlookAccesToken={outlookAccesToken} setLogout={setLogout}/>
        </div>
      </AuthProvider>
    </div>
  );
};

App.propTypes = {
  title: PropTypes.string,
};

export default App;
